import Menu from "../assets/images/menu.svg";
import Close from "../assets/images/close.svg";
import ArrowRightWhite from "../assets/images/arrow_right_white.svg";
import PlayWhite from "../assets/images/play_white.svg";
import PlayBlack from "../assets/images/play_black.svg";
import EmailWhite from "../assets/images/mail_white.svg";
import CallWhite from "../assets/images/call_white.svg";
import LocationWhite from "../assets/images/location_white.svg";
import ClockWhite from "../assets/images/clock_white.svg";
import Email from "../assets/images/mail.svg";
import Call from "../assets/images/call.svg";
import Location from "../assets/images/location.svg";
import UiUx from "../assets/images/uiux_icon.svg";
import WebDevelopment from "../assets/images/web_development_icon.svg";
import DigitalMarketing from "../assets/images/digital_marketing_icon.svg";
import MobileDevelopment from "../assets/images/mobile_development_icon.svg";
import FacebookBlack from "../assets/images/facebook_black.svg";
import FacebookWhite from "../assets/images/facebook_white.svg";
import InstagramBlack from "../assets/images/instagram_black.svg";
import InstagramWhite from "../assets/images/instagram_white.svg";
import TwitterBlack from "../assets/images/twitter_black.svg";
import TwitterWhite from "../assets/images/twitter_white.svg";
import LinkedlinBlack from "../assets/images/linkedin_black.svg";
import LinkedlinWhite from "../assets/images/linkedin_white.svg";
import ResultWhite from "../assets/images/result_white.svg";
import UsersWhite from "../assets/images/users_white.svg";
import BadgeWhite from "../assets/images/badge_white.svg";
import FantasyGamming from "../assets/images/fantasy_gamming_img.svg";
import ECommerce from "../assets/images/e_commerce_img.svg";
import LMS from "../assets/images/lms_img.svg";
import PublicServices from "../assets/images/public_service_img.svg";
import RentalProperty from "../assets/images/rental_property_img.svg";
import SocialMedial from "../assets/images/social_media_img.svg";
import HealthAndFitness from "../assets/images/health_and_fitness_img.svg";
import Tick from "../assets/images/tick.svg";
import ViewDoc from "../assets/images/view_doc.svg";
import Star from "../assets/images/star.svg";
import Global from "../assets/images/global.svg";
import Lighting from "../assets/images/lighting.svg";
import Layer from "../assets/images/layers.svg";
import Structure from "../assets/images/structure.svg";
import Code from "../assets/images/code.svg";
import Flexible from "../assets/images/flexible.svg";
import Rapid from "../assets/images/rapid.svg";
import ReactNative from "../assets/images/reactnative_img.svg";
import React from "../assets/images/reactJS_logo.svg";
import Node from "../assets/images/node_img.svg";
import Mongodb from "../assets/images/mongodb_img.svg";
import Postgresql from "../assets/images/postgresql_img.svg";
import Graphql from "../assets/images/graphql_img.svg";
import ArrowRightGrey from "../assets/images/right_arrow_grey.svg";
import ArrowBlue from "../assets/images/arrow_blue.svg";
import EyeBlue from "../assets/images/eye.svg";
import GraphBlue from "../assets/images/increase.svg";
import GlobalTheme from "../assets/images/global_theme.svg";
import LayersTheme from "../assets/images/layers_theme.svg";
import MobileAppTheme from "../assets/images/mobile_app_theme.svg";
import MonitorTheme from "../assets/images/monitor_theme.svg";

const Images = {
  SVG_MENU_ICON: Menu,
  SVG_CLOSE_ICON: Close,
  SVG_ARROW_RIGHT_WHITE_ICON: ArrowRightWhite,
  SVG_PLAY_WHITE_ICON: PlayWhite,
  SVG_PLAY_BLACK_ICON: PlayBlack,
  SVG_EMAIL_WHITE_ICON: EmailWhite,
  SVG_CALL_WHITE_ICON: CallWhite,
  SVG_LOCATION_WHITE_ICON: LocationWhite,
  SVG_CLOCK_WHITE_ICON: ClockWhite,
  SVG_EMAIL_ICON: Email,
  SVG_CALL_ICON: Call,
  SVG_LOCATION_ICON: Location,
  SVG_DIGITAL_MARKETING_ICON: DigitalMarketing,
  SVG_WEB_DEVELOPMENT_ICON: WebDevelopment,
  SVG_MOBILE_DEVELOPMENT_ICON: MobileDevelopment,
  SVG_UI_UX_ICON: UiUx,
  SVG_INSTAGRAM_BLACK_ICON: InstagramBlack,
  SVG_INSTAGRAM_WHITE_ICON: InstagramWhite,
  SVG_FACEBOOK_BLACK_ICON: FacebookBlack,
  SVG_FACEBOOK_WHITE_ICON: FacebookWhite,
  SVG_TWITTER_BLACK_ICON: TwitterBlack,
  SVG_TWITTER_WHITE_ICON: TwitterWhite,
  SVG_LINKEDLIN_BLACK_ICON: LinkedlinBlack,
  SVG_LINKEDLIN_WHITE_ICON: LinkedlinWhite,
  SVG_BADGE_WHITE_ICON: BadgeWhite,
  SVG_USERS_WHITE_ICON: UsersWhite,
  SVG_RESULT_WHITE_ICON: ResultWhite,
  SVG_FANTASY_GAMMING_ICON: FantasyGamming,
  SVG_E_COMMERCE_ICON: ECommerce,
  SVG_HEALTH_AND_FITNESS_ICON: HealthAndFitness,
  SVG_RENTAL_PROPERTY_ICON: RentalProperty,
  SVG_SOCIAL_MEDIA_ICON: SocialMedial,
  SVG_PUBLIC_SERVICES_ICON: PublicServices,
  SVG_LMS_ICON: LMS,
  SVG_TICK_ICON: Tick,
  SVG_VIEW_DOC_ICON: ViewDoc,
  SVG_STAR_ICON: Star,
  SVG_STRUCTURE_ICON: Structure,
  SVG_CODE_ICON: Code,
  SVG_LAYER_ICON: Layer,
  SVG_LIGHTING_ICON: Lighting,
  SVG_GLOBAL_ICON: Global,
  SVG_FLEXIBLE_ICON: Flexible,
  SVG_RAPID_ICON: Rapid,
  SVG_REACT_NATIVE_ICON: ReactNative,
  SVG_REACT_ICON: React,
  SVG_MONGODB_ICON: Mongodb,
  SVG_POSTGRESQL_ICON: Postgresql,
  SVG_GRAPHQL_ICON: Graphql,
  SVG_NODE_ICON: Node,
  SVG_ARROW_RIGHT_GREY_ICON: ArrowRightGrey,
  SVG_ARROW_BLUE: ArrowBlue,
  SVG_EYE_BLUE_ICON: EyeBlue,
  SVG_GRAPH_BLUE: GraphBlue,
  SVG_GLOBAL_THEME: GlobalTheme,
  SVG_LAYERS_THEME: LayersTheme,
  SVG_MOBILE_APP_THEME: MobileAppTheme,
  SVG_MONITOR_THEME: MonitorTheme,
};

export default Images;
